import React from 'react'
import { Translation } from 'locale'
import { GridSettingToggleSwitch } from 'view/components/datagrid/toolbar/GridSettingToggleSwitch'

export const IncludeTerminatedToolbarSwitch: React.FC = () => (
  <GridSettingToggleSwitch label={Translation.TC_INCLUDE_TERMINATED} setting="showTerminatedRepos" />
)
